/**
 * FWZ Multi-colonnes Component
 * Pour les sections Shopify avec galerie carousel et lightbox
 */

window.FWZMultiColumn = window.FWZMultiColumn || {
  instances: {},
  
  init: function(sectionId, options) {
    console.log('Initializing FWZMultiColumn for section:', sectionId);
    
    // Paramètres par défaut
    var settings = {
      autoSlide: options.autoSlide !== false, // true par défaut
      slideDuration: options.slideDuration || 5000,
      imagesPerSlide: options.imagesPerSlide || 4
    };
    
    // Chercher la section
    var sectionElement = document.querySelector('#shopify-section-' + sectionId) || 
                        document.querySelector('[data-section-id="' + sectionId + '"]');
    
    if (!sectionElement) {
      console.warn('Section element not found for:', sectionId);
      return;
    }
    
    var gallery = sectionElement.querySelector('.fwz-multicolumn__gallery');
    if (!gallery) {
      console.warn('Gallery element not found in section:', sectionId);
      return;
    }
    
    // Éviter la double initialisation
    if (gallery.getAttribute('data-initialized') === 'true') {
      console.log('Gallery already initialized for section:', sectionId);
      return;
    }
    gallery.setAttribute('data-initialized', 'true');
    
    var slidesContainer = gallery.querySelector('[data-gallery-slides]') || 
                         gallery.querySelector('.fwz-multicolumn__gallery-slides');
    var slides = gallery.querySelectorAll('.fwz-multicolumn__gallery-slide');
    var prevBtn = gallery.querySelector('[data-nav-prev]') || 
                  gallery.querySelector('.fwz-multicolumn__nav-btn:first-child');
    var nextBtn = gallery.querySelector('[data-nav-next]') || 
                  gallery.querySelector('.fwz-multicolumn__nav-btn:last-child');
    var dots = gallery.querySelectorAll('[data-dot-index]') || 
               gallery.querySelectorAll('.fwz-multicolumn__dot');
    
    // Éléments lightbox
    var lightboxTriggers = gallery.querySelectorAll('[data-lightbox-trigger]') || 
                          gallery.querySelectorAll('.fwz-multicolumn__gallery-image');
    var lightbox = sectionElement.querySelector('[data-lightbox]') || 
                   sectionElement.querySelector('.fwz-lightbox');
    var lightboxClose = lightbox ? lightbox.querySelector('[data-lightbox-close]') || 
                                  lightbox.querySelector('.fwz-lightbox__close') : null;
    
    var currentSlide = 0;
    var totalSlides = slides.length;
    var autoSlideInterval = null;
    
    // Vérifier qu'il y a des slides
    if (totalSlides === 0) {
      console.warn('No slides found in gallery for section:', sectionId);
      return;
    }
    
    console.log('Found', totalSlides, 'slides in section:', sectionId);
    
    // Fonctions du carousel
    function showSlide(index) {
      if (index < 0) index = totalSlides - 1;
      if (index >= totalSlides) index = 0;
      
      currentSlide = index;
      
      // Mettre à jour la position des slides
      if (slidesContainer) {
        slidesContainer.style.transform = 'translateX(-' + (currentSlide * 100) + '%)';
      }
      
      // Mettre à jour les dots
      dots.forEach(function(dot, i) {
        if (i === currentSlide) {
          dot.classList.add('active');
        } else {
          dot.classList.remove('active');
        }
      });
      
      console.log('Showing slide:', index, 'in section:', sectionId);
    }
    
    function nextSlide() {
      showSlide(currentSlide + 1);
    }
    
    function prevSlide() {
      showSlide(currentSlide - 1);
    }
    
    function startAutoSlide() {
      if (settings.autoSlide && totalSlides > 1) {
        stopAutoSlide();
        autoSlideInterval = setInterval(nextSlide, settings.slideDuration);
        console.log('Auto-slide started for section:', sectionId);
      }
    }
    
    function stopAutoSlide() {
      if (autoSlideInterval) {
        clearInterval(autoSlideInterval);
        autoSlideInterval = null;
      }
    }
    
    // Fonctions lightbox
    function openLightbox() {
      if (lightbox) {
        lightbox.classList.add('active');
        document.body.style.overflow = 'hidden';
        console.log('Lightbox opened for section:', sectionId);
      }
    }
    
    function closeLightbox() {
      if (lightbox) {
        lightbox.classList.remove('active');
        document.body.style.overflow = '';
        console.log('Lightbox closed for section:', sectionId);
      }
    }
    
    // Event listeners pour la navigation du carousel
    if (nextBtn) {
      nextBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        console.log('Next button clicked in section:', sectionId);
        stopAutoSlide();
        nextSlide();
        startAutoSlide();
      });
    }
    
    if (prevBtn) {
      prevBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        console.log('Prev button clicked in section:', sectionId);
        stopAutoSlide();
        prevSlide();
        startAutoSlide();
      });
    }
    
    // Event listeners pour les dots
    dots.forEach(function(dot, index) {
      dot.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        var slideIndex = parseInt(dot.getAttribute('data-dot-index')) || index;
        console.log('Dot clicked:', slideIndex, 'in section:', sectionId);
        stopAutoSlide();
        showSlide(slideIndex);
        startAutoSlide();
      });
    });
    
    // Event listeners pour la lightbox
    lightboxTriggers.forEach(function(trigger) {
      trigger.addEventListener('click', function(e) {
        e.preventDefault();
        openLightbox();
      });
    });
    
    if (lightboxClose) {
      lightboxClose.addEventListener('click', function(e) {
        e.preventDefault();
        closeLightbox();
      });
    }
    
    // Fermer lightbox en cliquant en dehors
    if (lightbox) {
      lightbox.addEventListener('click', function(e) {
        if (e.target === lightbox) {
          closeLightbox();
        }
      });
    }
    
    // Pause auto-slide au survol
    if (gallery) {
      gallery.addEventListener('mouseenter', stopAutoSlide);
      gallery.addEventListener('mouseleave', startAutoSlide);
    }
    
    // Support tactile pour le carousel
    var touchStartX = 0;
    var touchEndX = 0;
    
    if (gallery) {
      gallery.addEventListener('touchstart', function(e) {
        touchStartX = e.changedTouches[0].screenX;
      });
      
      gallery.addEventListener('touchend', function(e) {
        touchEndX = e.changedTouches[0].screenX;
        handleSwipe();
      });
    }
    
    function handleSwipe() {
      var swipeThreshold = 50;
      var diff = touchStartX - touchEndX;
      
      if (Math.abs(diff) > swipeThreshold) {
        stopAutoSlide();
        if (diff > 0) {
          nextSlide();
        } else {
          prevSlide();
        }
        startAutoSlide();
      }
    }
    
    // Sauvegarder l'instance
    this.instances[sectionId] = {
      showSlide: showSlide,
      nextSlide: nextSlide,
      prevSlide: prevSlide,
      openLightbox: openLightbox,
      closeLightbox: closeLightbox,
      stopAutoSlide: stopAutoSlide,
      startAutoSlide: startAutoSlide,
      cleanup: function() {
        stopAutoSlide();
        gallery.removeAttribute('data-initialized');
        console.log('FWZ MultiColumn cleaned up for section:', sectionId);
      }
    };
    
    // Initialiser
    showSlide(0);
    startAutoSlide();
    
    console.log('FWZ MultiColumn initialized successfully for section:', sectionId);
  },
  
  // Nettoyage d'une instance
  cleanup: function(sectionId) {
    if (this.instances[sectionId]) {
      this.instances[sectionId].cleanup();
      delete this.instances[sectionId];
    }
  },
  
  // Nettoyage de toutes les instances
  cleanupAll: function() {
    for (var sectionId in this.instances) {
      this.cleanup(sectionId);
    }
  }
};

// Initialisation automatique au chargement
document.addEventListener('DOMContentLoaded', function() {
  console.log('FWZMultiColumn: DOM Content Loaded');
  
  // Chercher toutes les sections multi-colonnes
  var multiColumnSections = document.querySelectorAll('[id^="shopify-section-"].fwz-multicolumn-section, [data-section-id][class*="multicolumn"]');
  
  multiColumnSections.forEach(function(section) {
    var sectionId = section.id ? section.id.replace('shopify-section-', '') : section.getAttribute('data-section-id');
    
    if (sectionId) {
      var autoSlide = section.getAttribute('data-auto-slide') !== 'false'; // true par défaut
      var slideDuration = parseInt(section.getAttribute('data-slide-duration')) || 5000;
      
      window.FWZMultiColumn.init(sectionId, {
        autoSlide: autoSlide,
        slideDuration: slideDuration
      });
    }
  });
});

// Support pour le thème customizer de Shopify
document.addEventListener('shopify:section:load', function(event) {
  var sectionId = event.target.id.replace('shopify-section-', '');
  
  if (event.target.classList.contains('fwz-multicolumn-section') || 
      event.target.querySelector('.fwz-multicolumn')) {
    console.log('Shopify multi-column section loaded:', sectionId);
    
    setTimeout(function() {
      var autoSlide = event.target.getAttribute('data-auto-slide') !== 'false';
      var slideDuration = parseInt(event.target.getAttribute('data-slide-duration')) || 5000;
      
      window.FWZMultiColumn.init(sectionId, {
        autoSlide: autoSlide,
        slideDuration: slideDuration
      });
    }, 100);
  }
});

document.addEventListener('shopify:section:unload', function(event) {
  var sectionId = event.target.id.replace('shopify-section-', '');
  
  if (event.target.classList.contains('fwz-multicolumn-section') || 
      event.target.querySelector('.fwz-multicolumn')) {
    console.log('Shopify multi-column section unloaded:', sectionId);
    window.FWZMultiColumn.cleanup(sectionId);
  }
});

// Observer pour les sections chargées dynamiquement (AJAX, etc.)
// Guard idempotent : évite la re-déclaration si le script est chargé deux fois
if (!window.__fwzMulticolumnObserver) {
window.__fwzMulticolumnObserver = new MutationObserver(function(mutations) {
  mutations.forEach(function(mutation) {
    mutation.addedNodes.forEach(function(node) {
      if (node.nodeType === 1 && node.classList) {
        var isMultiColumnSection = node.classList.contains('fwz-multicolumn-section') || 
                                  node.querySelector && node.querySelector('.fwz-multicolumn');
        
        if (isMultiColumnSection) {
          var sectionElement = node.closest('[id^="shopify-section-"]') || 
                              node.querySelector('[data-section-id]') || 
                              (node.hasAttribute('data-section-id') ? node : null);
          
          if (sectionElement) {
            var sectionId = sectionElement.id ? 
                           sectionElement.id.replace('shopify-section-', '') : 
                           sectionElement.getAttribute('data-section-id');
            
            if (sectionId) {
              var autoSlide = sectionElement.getAttribute('data-auto-slide') !== 'false';
              var slideDuration = parseInt(sectionElement.getAttribute('data-slide-duration')) || 5000;
              
              console.log('Dynamic multi-column section detected:', sectionId);
              
              setTimeout(function() {
                window.FWZMultiColumn.init(sectionId, {
                  autoSlide: autoSlide,
                  slideDuration: slideDuration
                });
              }, 200);
            }
          }
        }
      }
    });
  });
});

// Démarrer l'observation
window.__fwzMulticolumnObserver.observe(document.body, {
  childList: true,
  subtree: true
});
} // fin du guard idempotent

// Gestion globale de la touche Escape pour les lightboxes
document.addEventListener('keydown', function(e) {
  if (e.key === 'Escape') {
    var activeLightbox = document.querySelector('.fwz-lightbox.active');
    if (activeLightbox) {
      activeLightbox.classList.remove('active');
      document.body.style.overflow = '';
    }
  }
});

// Nettoyage avant le déchargement
window.addEventListener('beforeunload', function() {
  window.FWZMultiColumn.cleanupAll();
});

// Fonction globale pour forcer l'initialisation
window.initFWZMultiColumn = function(sectionId, autoSlide, slideDuration) {
  console.log('Force initializing FWZ MultiColumn:', sectionId, autoSlide, slideDuration);
  window.FWZMultiColumn.init(sectionId, {
    autoSlide: autoSlide !== false,
    slideDuration: slideDuration || 5000
  });
};